import moment from 'moment';

export const isDateAfterToday = (dateString: string): boolean => {
  const today = moment().format('MM/DD/YYYY');
  const dateEntered = moment(dateString, 'MM/DD/YYYY', true);
  return dateEntered.isAfter(today);
};

export const isDateBeforeToday = (dateString: string): boolean => {
  const today = moment().format('MM/DD/YYYY');
  const dateEntered = moment(dateString, 'MM/DD/YYYY', true);
  return dateEntered.isBefore(today);
};

export const isDateValid = (dateString: string): boolean => {
  const dateEntered = moment(dateString, 'MM/DD/YYYY', true);
  return dateEntered.isValid();
};

export const getFormattedDate = (dateString: string): string => {
  const dateEntered = moment(dateString, 'MM/DD/YYYY', true);
  return `${dateEntered.format('YYYY-MM-DD[T]HH:mm:ss.SSS')}0000`;
};

export const getFormattedLongDate = (dateString: string): string => {
  const longDate = moment(dateString, 'ddd MMM DD YYYY', true);
  const shortDate = longDate.format('MM/DD/YYYY');
  return shortDate;
};
